import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { TransitionGroup } from 'react-transition-group'

import { CarouselSlide } from 'components/molecules'
import { extractLayoutFromContent } from 'utils/layout'

import * as S from './styled'
import { DEFAULT_CONTENT_TIME, DEFAULT_TRANSITION_TIME } from 'constants/appConstants'

const Carousel = ({ contentList, setContentAttributes }) => {
  const [activeContent, setActiveContent] = useState(0)
  const [contentTime, setContentTime] = useState(DEFAULT_CONTENT_TIME)

  const updateAttributes = content => {
    const { contentType } = content
    const layout = extractLayoutFromContent(content)

    if (contentType || layout) {
      setContentAttributes({ contentType, layout })
    }
  }

  useEffect(() => {
    const customActiveContentTime = contentList[activeContent]?.newDuration * 1000
    setContentTime(customActiveContentTime || DEFAULT_CONTENT_TIME)
    setActiveContent(0)

    if (!contentList[activeContent]) {
      return
    }

    updateAttributes(contentList[activeContent])
  }, [contentList])

  const changeActiveContent = () => {
    const nextContent = activeContent < contentList.length - 1 ? activeContent + 1 : 0
    const customNextContentTime = contentList[nextContent]?.newDuration * 1000
    setContentTime(customNextContentTime || DEFAULT_CONTENT_TIME)

    setActiveContent(nextContent)
    if (contentList[nextContent]) {
      updateAttributes(contentList[nextContent])
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      changeActiveContent()
    }, contentTime)

    return () => clearInterval(interval)
  }, [activeContent, contentList, contentTime])

  return (
    contentList.length > 0 && (
      <S.CarouselContainer>
        <TransitionGroup>
          {contentList[activeContent] && (
            <CarouselSlide
              key={`${contentList[activeContent].contentType}_${activeContent}`}
              content={contentList[activeContent]}
              timeout={DEFAULT_TRANSITION_TIME}
              setContentTime={setContentTime}
            />
          )}
        </TransitionGroup>
      </S.CarouselContainer>
    )
  )
}

Carousel.defaultProps = {
  contentList: [],
  setContentAttributes: () => {},
}

Carousel.propTypes = {
  contentList: PropTypes.array,
  setContentAttributes: PropTypes.func,
}

export default Carousel
